import { Venda } from '@/models';
import store from '@/store/vuex'
import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";

const VENDA_VITRINE_VIRTUAL_STORAGE = 'VENDA_VITRINE_VIRTUAL_STORAGE'


export interface DadosVitrineVirtual {
	venda: Venda | null
  }
  
const DEFAULT_STATE: DadosVitrineVirtual = {
	venda: null,
}

function salvarNoLocalStorage(state: DadosVitrineVirtual) {
	localStorage.setItem(VENDA_VITRINE_VIRTUAL_STORAGE, JSON.stringify(state))
}
  
function lerDoLocalStorage(): DadosVitrineVirtual {
	const raw = localStorage.getItem(VENDA_VITRINE_VIRTUAL_STORAGE)
	return raw ? JSON.parse(raw) : DEFAULT_STATE
}

@Module({
	name: "VendaVitrineVirtualStore",
	namespaced: true,
	dynamic: true,
	store,
})
export default class VendaVitrineVirtualStore extends VuexModule {
	dados: DadosVitrineVirtual = lerDoLocalStorage()

	@Mutation
	setDados(parcial: Partial<DadosVitrineVirtual>) {
		this.dados = { ...this.dados, ...parcial } 
		salvarNoLocalStorage(this.dados)
	}
  
	@Mutation
	resetar() {
		this.dados = { ...DEFAULT_STATE }
		salvarNoLocalStorage(this.dados)
	}
}

export const VendaVitrineVirtualModule = getModule(VendaVitrineVirtualStore)
